import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "name": "CSS Grid Debugging"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live xray",
        "live": true,
        "xray": true
      }}>{`<div
  sx={{
    display: 'grid',
    gridGap: 3,
    gridTemplateColumns: 'repeat(2, 1fr)',
  }}>
  <div
    sx={{
      gridColumnStart: '1',
      gridColumnEnd: '3',
    }}>
    A
  </div>
  <div>B</div>
  <div>C</div>
</div>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      